import { useParams } from "react-router-dom";
import TemplateEditor from "./TemplateEditor";

export default function ProposalDocument() {
  const { id } = useParams();
  return <TemplateEditor proposalId={id} />;
}
